export default class ProvidedField {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.requiredFieldId = jsonResponse["required-field-id"];
            this.requiredFieldValue = jsonResponse["required-field-value"];
            this.providedFieldName = jsonResponse["provided-field-name"];
            this.providedFieldDisplayName = jsonResponse["provided-field-display-name"];
        }
    }
}